import React, { useEffect, useState } from 'react';
import { makeGetRequest } from '../services/httpHelper';
import ErrorHandler from '../services/ErrorHandler';



const FooterSocialMedia = () => {
  const [socialMedia, setSocialMedia] = useState([]);
   const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const church = JSON.parse(localStorage.getItem('church'));

    const fetchChurchSociaMedia = async () => {
    setIsLoading(true);
    const res = await makeGetRequest(`church-social-media/${church.id}`);

    if (res && res.errorType) {
      setIsLoading(false);
      const errorMessage = ErrorHandler(res);
      setError(errorMessage);
    } else {
        console.log('Sociam Media',res.data)
      setSocialMedia(res.data || [])
      setIsLoading(false);
      setError(null);
    }
  };


  useEffect(() => {

    fetchChurchSociaMedia()   

  
  }, []);

  if (socialMedia.length === 0) return null; // Do not render the section if none

  const getIcon = (platform) => {

    switch (platform) {
      case 'facebook':
        return <i className="fab fa-facebook-f" />;
      case 'x':
        return <i className="fab fa-x-twitter" />; // Twitter/X icon
      case 'linkedin':
        return <i className="fab fa-linkedin-in" />;
    
        case 'youtube':
        return <i className="fab fa-youtube" />;

      default:
        return <i className="fas fa-globe" />;
    }
  };
 

  return (
    <div className="footer-social-media">
        <link
  rel="stylesheet"
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css"
/>
      <h5>Connect With Us</h5>
       {error && <p className="text-danger">{error}</p>}
      <div className="social-links">
        {socialMedia.map((item) => (
          <a
            key={item.id}
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            className={`social-icon ${item.social_media}`}
          >
            {getIcon(item.social_media)}
          </a>
        ))}
      </div>

      {/* Optional styling */}
      <style jsx>{`
        .footer-social-media {
          margin-top: 20px;
          text-align: center;
        }

        .social-links {
          display: flex;
          justify-content: center;
          gap: 15px;
        }

        .social-icon {
          font-size: 1.5rem;
          color: #fff;
          transition: color 0.3s;
        }

        .social-icon:hover {
          color: #f0ad4e;
        }
      `}</style>
    </div>
  );
};

export default FooterSocialMedia;
